import React, {useMemo, forwardRef} from "react";
import {StyleSheet, Text} from "react-native";
import {Paragraph} from "../../base/typography";
import type {ParagraphProps} from "../../base/typography/Paragraph";
import {interFontFamilies} from "../../base/typography/styles";

export const ProParagraph = forwardRef<Text, ParagraphProps>(function ProParagraph(
  {weight = "regular", level = 1, legacyStyle, ...props},
  ref,
) {
  const style = useMemo(() => {
    return [paragraphStyles[level], interFontFamilies[weight], legacyStyle];
  }, [level, weight, legacyStyle]);
  return <Paragraph ref={ref} style={style} {...props} />;
});

export const paragraphStyles = StyleSheet.create({
  1: {
    fontSize: 16,
    lineHeight: 24,
  },
  2: {
    fontSize: 14,
    lineHeight: 20,
  },
  3: {
    fontSize: 12,
    lineHeight: 20,
  },
});

export default ProParagraph;
